import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'

import { map, keyBy, isEmpty } from 'lodash'
import { Grid } from '@material-ui/core'

import ChipsLoadingSkeleton from './ChipsLoadingSkeleton'
import Chip from './Chip'

const ChipSelector = ({ loading, options, selected, onUpdateSelection }) => {
  const selectedObj = useMemo(() => keyBy(selected, 'value'), [selected])

  const onToggle = useCallback(
    (option) => {
      const { value } = option
      const alreadySelected = !isEmpty(selectedObj[value])
      let newOptions = [...selected]
      if (alreadySelected) {
        newOptions = newOptions.filter((option) => option.value !== value)
      } else {
        newOptions.push(option)
      }
      onUpdateSelection(newOptions, option)
    },
    [selected, selectedObj, onUpdateSelection],
  )

  return loading ? (
    <ChipsLoadingSkeleton />
  ) : (
    <Grid
      container
      spacing={1}
    >
      {map(options, (option) => {
        const { label, value, icon } = option
        return (
          <Grid
            item
            key={value}
          >
            <Chip
              label={label}
              onClick={() => onToggle(option)}
              isSelected={!isEmpty(selectedObj[value])}
              icon={icon}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}

ChipSelector.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      icon: PropTypes.any,
    }),
  ),
  selected: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      icon: PropTypes.any,
    }),
  ),
  onUpdateSelection: PropTypes.func,
  loading: PropTypes.bool,
}

export default ChipSelector
